<template>
	<view class="shop-mine-page">
		<view :style="{ height: statusbarHeight + 'px' }"></view>
		<view class="header">
			<text class="title">我的</text>
		</view>
		<view class="content">
			<text>门店我的页面</text>
		</view>
		<custom-tabbar></custom-tabbar>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	import CustomTabbar from '@/components/custom-tabbar/custom-tabbar.vue'

	export default {
		components: {
			CustomTabbar
		},
		computed: {
			...mapState(['statusbarHeight'])
		}
	}
</script>

<style lang="scss" scoped>
	.shop-mine-page {
		min-height: 100vh;
		background: #f8f8f8;
	}
	.header {
		padding: 30rpx;
		.title {
			font-size: 40rpx;
			font-weight: 600;
		}
	}
	.content {
		padding: 30rpx;
	}
</style>
